module.exports = __webpack_public_path__ + "e6d94cb3dff24304bf99447dd0cfed4c.png";